module.exports = __webpack_public_path__ + "static/img/content-img.d253be0f.webp";